export const marketplace = {
  marketplaceSearchInputPlaceholderTitle: 'Пошук',
  marketplaceDetailsCurtainCopyOptionTitle: 'Скопіювати посилання',
  marketplaceDetailsCurtainFlagOptionTitle: 'Поскаржитись на контент',
  marketplaceDetailsCurtainCopiedAlertText: 'Посилання скопійовано!',
  marketplaceDetailsFlagCurtainTitle: 'Поскаржитись',
  marketplaceReportedCurtainContent: 'Скаргу надісланно',
  marketplaceAllItems: 'Усі товари',
  marketplaceWantToBuy: 'Хочу купити {item} з {appname}'
}
